import axios from 'axios';
import Api from '@/plugins/api';

export default {
  fetchToken(context, form) {
    const Axios = axios.create({
      baseURL: process.env.VUE_APP_API_HOST,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (context.state.account.token) {
      return context.dispatch('refreshToken', form);
    }
    const postData = {
      username: form && form.login ? form.login : process.env.VUE_APP_API_LOGIN,
      password: form && form.password ? form.password : process.env.VUE_APP_API_PASSWORD,
    };

    return Axios.post('api/auth/login', postData).then((response) => {
      context.commit('setToken', response.data.data);
    }).catch((errors) => {
      context.dispatch('errors/addError', errors, { root: true });
    });
  },
  refreshToken(context, form) {
    const Axios = axios.create({
      baseURL: process.env.VUE_APP_API_HOST,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });

    const postData = {
      username: form && form.login ? form.login : process.env.VUE_APP_API_LOGIN,
      password: form && form.password ? form.password : process.env.VUE_APP_API_PASSWORD,
    };

    return Axios.post('api/auth/login', postData).then((response) => {
      context.commit('setToken', response.data.data);
    });
  },
  removeToken(context) {
    context.commit('removeToken');
  },
  getCurrentUser(context) {
    const store = context;
    store.state.user.loading = true;
    const promise = Api(store).get('api/user/current');
    promise.then((response) => {
      store.commit('setUser', response.data);
    });
    promise.finally(() => {
      store.state.user.loading = false;
      store.state.user.init = true;
    });

    return promise;
  },
};
